export default "__VITE_ASSET__QAW11aQ9TuLzHd_oKG5$Vg__"